import React from "react";
import SolitaireCore from "../SolitaireCore";
import { cardBackForGameId } from "../SpectatedSolitaire";
import { fetchFinalBoard } from "../HistoryWindow/historyApi";

// A finished game, opened from Past Games: the final board, frozen —
// a lighter alternative to replay. Same 620x435 Solitaire window as
// everything else; nothing here is playable.

const EMPTY_STATE = Object.freeze({
  stock: [],
  waste: [],
  tableau: Array.from({ length: 7 }, () => ({ faceDown: [], faceUp: [] })),
  foundations: [[], [], [], []],
  drawSize: 3,
});

function PastGameWindow({ gameId, onClose, inactive = false }) {
  const [board, setBoard] = React.useState(null);
  React.useEffect(() => {
    let cancelled = false;
    // The one viewer window swaps games in place — drop the previous
    // game's board immediately so it can't wear the new title.
    setBoard(null);
    fetchFinalBoard(gameId)
      .then((b) => {
        if (!cancelled) setBoard(b);
      })
      .catch(() => {
        // The empty felt stands in; closing and reopening retries.
      });
    return () => {
      cancelled = true;
    };
  }, [gameId]);

  return (
    <SolitaireCore
      title={`(Past Game) Game #${gameId} — Solitaire Alone Together`}
      // Half-size assets, full-size chrome. Safe here because the board
      // is frozen — no cursors, no ritual, no cascade.
      boardScale={0.5}
      state={board ?? EMPTY_STATE}
      titleIcon="solitaire"
      cardBack={cardBackForGameId(gameId)}
      interactive={false}
      inactive={inactive}
      controls={["close"]}
      onControlClick={(control) => {
        if (control === "close" && onClose) onClose();
      }}
      menus={[
        { label: "Game", disabled: true },
        { label: "Help", disabled: true },
      ]}
    />
  );
}

export default PastGameWindow;
